// extracted by mini-css-extract-plugin
export default {"container":"Checkbox2_container__ibJwO"};